import { CoinID } from '@starsoft/common/enums';
import { Nullable } from '@starsoft/common/interfaces';
import { KycIdentityOriginId } from '../enums/kyc/identity/origin';
import { CoinIDType } from '../enums/coinId';

export namespace KycIdentityOriginNamespace {
  export function getIdentityOriginIdByCoinId(
    coinId: CoinIDType,
  ): Nullable<string> {
    switch (coinId?.toString()) {
      case CoinID.BRL?.toString():
        return KycIdentityOriginId.Brazil?.toString();
      case CoinID.INR?.toString():
        return KycIdentityOriginId.India?.toString();
      case CoinID.MXN?.toString():
        return KycIdentityOriginId.Mexico?.toString();
      case CoinID.ARS?.toString():
        return KycIdentityOriginId.Argentina?.toString();
      case CoinID.IDR?.toString():
        return KycIdentityOriginId.Indonesia?.toString();
      case CoinID.PEN?.toString():
        return KycIdentityOriginId.Peru?.toString();
      case CoinID.ZAR?.toString():
        return KycIdentityOriginId.SouthAfrica?.toString();
      case CoinID.NGN?.toString():
        return KycIdentityOriginId.Nigeria?.toString();
      case CoinID.SGD?.toString():
        return KycIdentityOriginId.Singapore?.toString();

      default:
        return null;
    }
  }
}
